import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getDevice } from '../../api/apiCalls';
import { useQuery } from '@tanstack/react-query';
import UniqueDeviceMap from '../mapComponents/uniqueDeviceMap';
import { LuMapPinOff } from "react-icons/lu";

function Device() {
    const { deveui } = useParams();
    const location = useLocation();
    const server = useParams().server || location.state?.server;

    const statusObject = {
        0: 'fail',
        1: 'active',
        2: 'init',
        3: 'error'
    };

    const { data: deviceData, isLoading: deviceIsLoading, isError: deviceIsError, error: deviceError, isSuccess: deviceIsSuccess } = useQuery({
        queryKey: ['getDevice', deveui, server],
        queryFn: () => getDevice(deveui, server),
    });

    useEffect(() => {
        if (deviceIsSuccess && deviceData?.data?.deviceData) {
            console.log(deviceData.data.deviceData);
        } else {
            console.log("deviceData is not ready yet or doesn't have expected structure.");
        }
    }, [deviceData, deviceIsSuccess]);

    // return (
    //     <div>
    //         <div className='flex flex-col lg:flex-row items-center justify-center mt-10 gap-10 lg:px-24'>
    //             <div className='flex flex-col w-full lg:w-[50%]'>
    //                 {deviceIsSuccess && deviceData?.data?.deviceData && (
    //                     <div className='container-inner-shadow p-2 lg:min-h-[500px]'>
    //                         <h2 className='text-[var(--textPrimary)] font-bold underline '>Device Details</h2>
    //                         <div className='grid grid-cols-2 gap-4'>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>DevEUI</p>
    //                                 <p>{deviceData.data.deviceData.deveui}</p>
    //                             </div>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>Name</p>
    //                                 <p>{deviceData.data.deviceData.name}</p>
    //                             </div>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>Status</p>
    //                                 <p>{statusObject[deviceData.data.deviceData.status]}</p>
    //                             </div>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>Last Up</p>
    //                                 <p>{deviceData.data.deviceData.lastUplink ? new Date(deviceData.data.deviceData.lastUplink).toLocaleString() : '-'}</p>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 )}
    //             </div>
    //             <div className="w-full lg:w-[50%] container-outer-shadow">
    //                 {deviceIsSuccess && deviceData?.data?.deviceData && deviceData?.data?.deviceData.latitude && deviceData?.data?.deviceData.longitude ? (
    //                     <MapComponent
    //                         center={[deviceData.data.deviceData.latitude, deviceData.data.deviceData.longitude]}
    //                         zoom={14}
    //                         pointer={{ latitude: deviceData.data.deviceData.latitude, longitude: deviceData.data.deviceData.longitude }}
    //                         status={deviceData.data.deviceData.status}
    //                     />
    //                 ) : (
    //                     <div className="min-h-[500px] flex flex-col items-center justify-center text-gray-500 gap-6">
    //                         <div>
    //                             <LuMapPinOff className='text-[6rem]'/>
    //                         </div>
    //                         <div>
    //                             <h1 className='font-bold'>
    //                                 No coordinates available
    //                             </h1>
    //                         </div>
    //                     </div>
    //                 )}
    //             </div>
    //         </div>

    //         {deviceIsSuccess && deviceData?.data?.deviceData &&
    //             <div className="flex flex-col lg:flex-row gap-10 mt-4 lg:px-24">
    //                 <div className='w-full lg:w-[50%]'>
    //                     <div className='container-inner-shadow p-2'>
    //                         <h2 className='text-[var(--textPrimary)] font-bold underline '>Last Signals Details</h2>
    //                         <div className='grid grid-cols-2 gap-4'>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>Last Up</p>
    //                                 <p>{deviceData.data.deviceData.lastUplink ? new Date(deviceData.data.deviceData.lastUplink).toLocaleString() : '-'}</p>
    //                             </div>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>SNR Last</p>
    //                                 <p>{deviceData.data.deviceData.lastSignals.snr !== null ? deviceData.data.deviceData.lastSignals.snr : '-'}</p>
    //                             </div>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>RSSI Last</p>
    //                                 <p>{deviceData.data.deviceData.lastSignals.rssi !== null ? deviceData.data.deviceData.lastSignals.rssi : '-'}</p>
    //                             </div>

    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>ESP Last</p>
    //                                 <p>{deviceData.data.deviceData.lastSignals.esp !== null ? deviceData.data.deviceData.lastSignals.esp : '-'}</p>
    //                             </div>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>SF Last</p>
    //                                 <p>{deviceData.data.deviceData.lastSignals.sf !== null ? deviceData.data.deviceData.lastSignals.sf : '-'}</p>
    //                             </div>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>Instant PER Last</p>
    //                                 <p>{deviceData.data.deviceData.lastSignals.lastInstantPER !== null ? deviceData.data.deviceData.lastSignals.lastInstantPER : '-'}</p>
    //                             </div>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>Mean PER Last</p>
    //                                 <p>{deviceData.data.deviceData.lastSignals.lastMeanPER !== null ? deviceData.data.deviceData.lastSignals.lastMeanPER : '-'}</p>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 <div className='w-full lg:w-[50%]'>
    //                     <div className='container-inner-shadow p-2'>
    //                         <h2 className='text-[var(--textPrimary)] font-bold underline '>Average Signals Details</h2>
    //                         <div className='grid grid-cols-2 gap-4'>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>SNR Average</p>
    //                                 <p>{deviceData.data.deviceData.snravg !== null ? deviceData.data.deviceData.averages.snravg : '-'}</p>
    //                             </div>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>RSSI Average</p>
    //                                 <p>{deviceData.data.deviceData.averages.rssiavg !== null ? deviceData.data.deviceData.averages.rssiavg : '-'}</p>
    //                             </div>
    //                             <div>
    //                                 <p className='text-[var(--textPrimary)] font-bold'>ESP Average</p>
    //                                 <p>{deviceData.data.deviceData.averages.espavg !== null ? deviceData.data.deviceData.averages.espavg : '-'}</p>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         }
    //     </div>
    // );

    return (
        <div>
            <div className='flex flex-col lg:flex-row items-center justify-center mt-10 gap-10 lg:px-24'>
                {/* Device Details Section */}
                <div className='flex flex-col w-full lg:w-[50%]'>
                    {deviceIsSuccess && deviceData?.data?.deviceData ? (
                        <div className='container-inner-shadow p-2 lg:min-h-[500px]'>
                            <h2 className='text-[var(--textPrimary)] font-bold underline '>Device Details</h2>
                            <div className='grid grid-cols-2 gap-4'>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>DevEUI</p>
                                    <p>{deviceData.data.deviceData.deveui}</p>
                                </div>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>Name</p>
                                    <p>{deviceData.data.deviceData.name}</p>
                                </div>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>Status</p>
                                    <p>{statusObject[deviceData.data.deviceData.status]}</p>
                                </div>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>Last Up</p>
                                    <p>{deviceData.data.deviceData.lastUplink ? new Date(deviceData.data.deviceData.lastUplink).toLocaleString('en-GB') : '-'}</p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className='container-inner-shadow p-2 lg:min-h-[500px] animate-pulse'>
                            <h2 className='text-[var(--textPrimary)] font-bold underline bg-[var(--skeleton-bg)] rounded-md h-6 w-1/3 mb-4 mx-auto mt-1'></h2>
                            <div className='grid grid-cols-2 gap-4'>
                                {[...Array(4)].map((_, index) => (
                                    <div key={index} className="flex flex-col items-center justify-center">
                                        <p className='font-bold bg-[var(--skeleton-bg)] rounded-md h-4 w-1/4 mb-2'></p>
                                        <p className='bg-[var(--skeleton-bg)] rounded-md h-4 w-1/2'></p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {/* Map Section */}
                <div className='w-full lg:w-[50%] container-outer-shadow'>
                    {deviceIsSuccess && deviceData?.data?.deviceData && deviceData?.data?.deviceData.latitude && deviceData?.data?.deviceData.longitude ? (
                        <UniqueDeviceMap
                            center={[deviceData.data.deviceData.latitude, deviceData.data.deviceData.longitude]}
                            zoom={14}
                            pointer={{ name: deviceData.data.deviceData.name, latitude: deviceData.data.deviceData.latitude, longitude: deviceData.data.deviceData.longitude }}
                            status={deviceData.data.deviceData.status}
                            lrrs={deviceData.data.deviceData.lrrs}
                        />
                    ) : (
                        <div className="min-h-[500px] flex flex-col items-center justify-center text-gray-500 gap-6">
                            <div>
                                <LuMapPinOff className='text-[6rem]' />
                            </div>
                            <div>
                                <h1 className='font-bold'>
                                    No coordinates available
                                </h1>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {deviceIsSuccess && deviceData?.data?.deviceData ? (
                <div className="flex flex-col lg:flex-row gap-10 mt-4 mb-4 lg:px-24">
                    {/* Last Signals Details */}
                    <div className='w-full lg:w-[50%]'>
                        <div className='container-inner-shadow p-2 min-h-full'>
                            <h2 className='text-[var(--textPrimary)] font-bold underline'>Last Signal Details</h2>
                            <div className='grid grid-cols-2 gap-4'>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>Last Uplink</p>
                                    <p>{deviceData.data.deviceData.lastUplink ? new Date(deviceData.data.deviceData.lastUplink).toLocaleString('en-GB') : '-'}</p>
                                </div>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>Last Downlink</p>
                                    <p>{deviceData.data.deviceData.lastDownlink ? new Date(deviceData.data.deviceData.lastDownlink).toLocaleString('en-GB') : '-'}</p>
                                </div>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>SNR Last</p>
                                    <p>{deviceData.data.deviceData.lastSignals.snr !== null ? deviceData.data.deviceData.lastSignals.snr : '-'}</p>
                                </div>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>RSSI Last</p>
                                    <p>{deviceData.data.deviceData.lastSignals.rssi !== null ? deviceData.data.deviceData.lastSignals.rssi : '-'}</p>
                                </div>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>ESP Last</p>
                                    <p>{deviceData.data.deviceData.lastSignals.esp !== null ? deviceData.data.deviceData.lastSignals.esp : '-'}</p>
                                </div>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>SF Last</p>
                                    <p>{deviceData.data.deviceData.lastSignals.sf !== null ? deviceData.data.deviceData.lastSignals.sf : '-'}</p>
                                </div>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>Instant PER Last</p>
                                    <p>{deviceData.data.deviceData.lastSignals.lastInstantPER !== null ? deviceData.data.deviceData.lastSignals.lastInstantPER : '-'}</p>
                                </div>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>Mean PER Last</p>
                                    <p>{deviceData.data.deviceData.lastSignals.lastMeanPER !== null ? deviceData.data.deviceData.lastSignals.lastMeanPER : '-'}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Average Signals Details */}
                    <div className='w-full lg:w-[50%]'>
                        <div className='container-inner-shadow p-2 min-h-full'>
                            <h2 className='text-[var(--textPrimary)] font-bold underline'>Average Signal Details</h2>
                            <div className='grid grid-cols-2 gap-4'>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>SNR Average</p>
                                    <p>{deviceData.data.deviceData.snravg !== null ? deviceData.data.deviceData.averages.snravg : '-'}</p>
                                </div>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>RSSI Average</p>
                                    <p>{deviceData.data.deviceData.averages.rssiavg !== null ? deviceData.data.deviceData.averages.rssiavg : '-'}</p>
                                </div>
                                <div>
                                    <p className='text-[var(--textPrimary)] font-bold'>ESP Average</p>
                                    <p>{deviceData.data.deviceData.averages.espavg !== null ? deviceData.data.deviceData.averages.espavg : '-'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="flex flex-col lg:flex-row gap-10 mt-4 mb-4 lg:px-24">
                    {/* Skeleton Loader for Last Signals Details */}
                    <div className='w-full lg:w-[50%]'>
                        <div className='container-inner-shadow p-2 animate-pulse min-h-full'>
                            <h2 className='font-bold underline bg-[var(--skeleton-bg)] rounded-md h-6 w-1/3 mb-4 mx-auto mt-1'></h2>
                            <div className='grid grid-cols-2 gap-4'>
                                {[...Array(8)].map((_, index) => (
                                    <div key={index} className="flex flex-col items-center justify-center">
                                        <p className='font-bold bg-[var(--skeleton-bg)] rounded-md h-4 w-1/2 mb-2'></p>
                                        <p className='bg-[var(--skeleton-bg)] rounded-md h-4 w-1/4'></p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Skeleton Loader for Average Signals Details */}
                    <div className='w-full lg:w-[50%]'>
                        <div className='container-inner-shadow p-2 animate-pulse min-h-full'>
                            <h2 className='font-bold underline bg-[var(--skeleton-bg)] rounded-md h-6 w-1/3 mb-4 mx-auto mt-1'></h2>
                            <div className='grid grid-cols-2 gap-4'>
                                {[...Array(3)].map((_, index) => (
                                    <div key={index} className="flex flex-col items-center justify-center">
                                        <p className='font-bold bg-[var(--skeleton-bg)] rounded-md h-4 w-1/2 mb-2'></p>
                                        <p className='bg-[var(--skeleton-bg)] rounded-md h-4 w-1/4'></p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Device;
